import React from "react";
import { withSiteData, withRouteData, Link } from "react-static";

import ImageGallery from "react-image-gallery";

const werkstattimages = [
  { original: "/werkstatt/Werkstatt_1.jpg" },
  { original: "/werkstatt/Werkstatt_2.jpg" },
  { original: "/werkstatt/Werkstatt_3.jpg" },
  { original: "/werkstatt/Werkstatt_4.jpg" },
  { original: "/werkstatt/Werkstatt_6.jpg" }
];
const referenzenimages = [
  { original: "/referenzen/referenzen00008.jpg" },
  { original: "/referenzen/referenzen00001.jpg" },
  { original: "/referenzen/referenzen00003.jpg" },
  { original: "/referenzen/referenzen00005.jpg" },
  { original: "/referenzen/referenzen00007.jpg" },
  { original: "/referenzen/referenzen00009.jpg" },
  { original: "/referenzen/referenzen00002.jpg" },
  { original: "/referenzen/referenzen00004.jpg" },
  { original: "/referenzen/referenzen00006.jpg" }
];
const images = [
  { original: "/cars/jaguar_01.jpg" },
  { original: "/cars/jaguar_03.jpg" },
  { original: "/cars/jaguar_04.jpg" },
  { original: "/cars/citroensm_01.jpg" },
  { original: "/cars/citroensm_02.jpg" },
  { original: "/cars/citroensm_03.jpg" }
];
//
export default withSiteData(props => (
  <div>
    <section className="left-section">
      <article className="textbox">
        <h2>Über Uns</h2>
        <p>
          Wir sind ein spezialisierter Fachbetrieb für Oldtimer und historischen
          Motorsport, dabei kümmern wir uns sowohl um ein- als auch um
          mehrspurige Fahrzeuge. Besitzer historischer KFZ wissen um die
          Eigenheiten alter Technik und die besonderen Herausforderungen in der
          Wiederherstellung und Erhaltung originaler Substanz. Diesem speziellen
          Wissen und besonderen Fähigkeiten haben wir uns in unserer beruflichen
          Tätigkeit voll und ganz verschrieben, und damit unser Hobby zum Beruf
          gemacht. Das historische Kraftfahrwesen ist bei uns kein
          "Nebenbei-Geschäft", sondern unsere ausschließliche und große
          Leidenschaft.
        </p>
      </article>
      <ImageGallery
        items={images}
        showThumbnails={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={true}
      />
    </section>
    <section className="right-section">
      <article className="right-textbox">
        <h2>Services</h2>
        <p>
          Wir bieten Ihnen ein umfassendes Service-Spektrum rund um den
          Oldtimer. Dies beinhaltet sämtliche Aufgaben zur Instandsetzung,
          Reparatur und Instandhaltung von Motoren, Getrieben, Antriebsstrang,
          Elektrik und Fahrwerk, sowie Karosserie- und Lackierarbeiten. Wir
          kümmern uns für unsere Kunden auch um den "Papierkram", §57a
          "Pickerl"-Untersuchungen, Wertgutachten, Einzelgenehmigung,
          Homologation für Rennfahrzeuge uvm. gehören bei uns zum
          selbstverständlichen Kundenservice. Genießen Sie Ihren Oldtimer - wir
          kümmern uns um den Rest!
        </p>
      </article>
      <ImageGallery
        items={werkstattimages}
        showThumbnails={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={true}
      />
    </section>
    <section className="left-section">
      <article className="textbox">
        <h2>Angebote & Referenzen</h2>
        <p>
          Unsere Arbeit kann sich sehen lassen! Hier ein paar unserer letzten
          Restaurierungen.
        </p>
      </article>
      <ImageGallery
        items={referenzenimages}
        showThumbnails={false}
        showFullscreenButton={false}
        showPlayButton={false}
        showBullets={true}
      />
    </section>
    <p />
  </div>
));



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Home.js